import WebGL from 'three/addons/capabilities/WebGL.js';
import { WebGL2UnavailableLazy } from 'modules/application/components/WebGL2UnavailableLazy';

import { captureException } from 'utils/captureException';

export interface CapabilitiesProps {
  children?: React.ReactNode;
}

export function SystemCapabilitiesCheck(props: CapabilitiesProps) {
  const { children } = props;

  if (!WebGL.isWebGL2Available()) {
    captureException(new Error('WebGL2 not available'));

    return <WebGL2UnavailableLazy />;
  }

  return children;
}
